let smoothScrollTo = require('../modules/smoothScrollTo');

class Scroll {
    static instance;

    constructor() {
        if (self.instance) {
            return instance;
        }

        self.instance = this;

        let header          = document.querySelector('header > nav');
        this._headerHeight  = header.offsetHeight;
        this._currentScroll = null;

        window.addEventListener('resize', () => {
            this._headerHeight = header.offsetHeight;
        });
    }

    to(element, callback = null, force = false) {
        let duration = 1000;

        if (this._currentScroll === null || force) {
            this._currentScroll = true;
            smoothScrollTo(element, {
                duration: duration,
                easing: 'easeOutQuart',
                offset: parseInt(this._headerHeight - 20)
            }, () => {
                if (callback !== null) {
                    callback();
                }
                this._currentScroll = null;
            });
        } else {
            if (callback !== null) {
                callback();
            }
        }
    }

}

module.exports = Scroll;